import React, { useState, useCallback } from "react";
import WinnerInfoForm from "./WinnerInfoForm";
import { EventButton, ValidatedInput } from "../common";

const InfoEditScreen = ({
  currentInfo,
  onSubmit,
  onCancel,
  loading,
  remainingModifications,
}) => {
  const [reason, setReason] = useState("");
  const [reasonError, setReasonError] = useState(null);

  const handleReasonChange = useCallback((e) => {
    setReason(e.target.value);
    setReasonError(null);
  }, []);

  const handleSubmit = useCallback(
    (formData) => {
      if (!reason.trim()) {
        setReasonError("수정 사유를 입력해주세요.");
        return;
      }
      onSubmit({ ...formData, reason: reason.trim() });
    },
    [reason, onSubmit]
  );

  return (
    <div className="newyear-info-edit">
      <div className="newyear-info-edit__header">
        <h2 className="newyear-info-edit__title">당첨자 정보 수정</h2>
      </div>

      <div className="newyear-info-edit__warning">
        <p>수정 가능 횟수는 제한되어 있습니다.</p>
        <p>정확한 정보를 입력해주세요.</p>
      </div>

      <WinnerInfoForm
        initialValues={{
          name: currentInfo?.name || "",
          phone: currentInfo?.phone || "",
        }}
        onSubmit={handleSubmit}
        loading={loading}
        submitLabel="수정 완료"
        remainingModifications={remainingModifications}
      />

      <div className="newyear-info-edit__reason">
        <ValidatedInput
          label="수정 사유"
          type="text"
          value={reason}
          onChange={handleReasonChange}
          placeholder="수정이 필요한 사유를 입력해주세요"
          maxLength={100}
          error={reasonError}
          required
          disabled={loading}
        />
      </div>

      <div className="newyear-info-edit__cancel">
        <EventButton
          variant="secondary"
          size="medium"
          onClick={onCancel}
          disabled={loading}
        >
          취소
        </EventButton>
      </div>
    </div>
  );
};

export default InfoEditScreen;
